import React, { useState, useEffect } from 'react';
import { FaSyncAlt } from 'react-icons/fa';
import JudgeTableRow from '../../../Components/subcomponents/JudgeTableRow';
import ResultModal from '../../../Components/Modals/ResultModal';
import JudgeForm from '../../../Components/Modals/RegisterJudgeModal';
import currentDomain from '../../../Utils/Utils';

function ViewJudges() {
  const [searchQuery, setSearchQuery] = useState('');
  const [entries, setEntries] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedEntry, setSelectedEntry] = useState(null); // State to track selected entry for modal
  const [isModalOpen, setIsModalOpen] = useState(false); // State to control modal visibility
  const [isRegJudgeOpen, setIsRegJudgeOpen] = useState(false); // State to control modal visibility

  // Fetch entries from the backend
  const fetchEntries = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${currentDomain(location)}/api/judge`);
      const data = await response.json();
      setEntries(data);

      // Extract unique classes
      // const uniqueClasses = [...new Set(data.map(entry => entry.class_name))];
      // setClasses(uniqueClasses);
    } catch (error) {
      toast.error('Failed to fetch judges');
    } finally {
      setIsLoading(false);
    }
  };

  // Initial fetch on component mount
  useEffect(() => {
    fetchEntries();
  }, []);

  // Handle refresh
  const handleRefresh = () => {
    fetchEntries(); // This will re-fetch the entries
  };

  // Function to open the modal and pass the selected entry data
  const handleEdit = (entry) => {
    setSelectedEntry(entry);
    setIsModalOpen(true);
  };

  // Function to close the modal
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedEntry(null);
    fetchEntries();
  };

const onJClose = () => {
  setIsRegJudgeOpen(false);
}

const onJOpen = () => {
  setIsRegJudgeOpen(true);
}

  // Filter entries based on selected class and search query
  const filteredEntries = entries
    .filter((entry) => {
      const query = searchQuery.toLowerCase();
      const fullName = `${entry.fname} ${entry.owner_lname}`.toLowerCase();
      const isPaidString = entry.isadmin ? "yes" : "no"; // Convert boolean to "Yes" or "No"

      return (
        (
          fullName.includes(query) || 
          entry.phone.includes(query) || 
          entry.email.includes(query) ||
          entry.uuid.includes(query) ||
          isPaidString.includes(query) // Include isPaid ("Yes" or "No") in the search
        )
      );
    })
    .sort((a, b) => {
      const query = searchQuery.toLowerCase();
      const aMatch = a.lname.toLowerCase().includes(query) || a.fname.toLowerCase().includes(query);
      const bMatch = b.lname.toLowerCase().includes(query) || b.fname.toLowerCase().includes(query);
      return aMatch === bMatch ? 0 : aMatch ? -1 : 1;
    });

  return (
    <div className='pb-12'>
      <div className='text-center'>
        <h1 className="font-bold text-2xl py-8">Judges</h1>
      </div>
      <div className="flex justify-between items-center pb-4 gap-20">
        

        <input
          type="text"
          placeholder="Search by name, phone, email, or uuid"
          className="border p-2 w-2/3"
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
        />
        <button onClick={onJOpen} className=''>
          Add Judge
        </button>
        <button onClick={handleRefresh} className=''>
          <FaSyncAlt />
        </button>
      </div>
      
      {isLoading ? <p>Loading...</p> : (
        <div className="overflow-auto pr-4">
          <table className="w-full border border-black">
            <thead>
              <tr className="bg-gray-200">
                <th className="text-l">#</th>
                <th className="text-l">Name</th>
                <th className="text-l">Phone</th>
                <th className="text-l">Email</th>
                <th className="text-l">Admin</th>
                <th className="text-l">Car's Judged</th>
                <th className="text-l"></th>
              </tr>
            </thead>
            <tbody className='text-sm'>
              
              {filteredEntries.length > 0 ? (
                filteredEntries.map((entry, index) => (
                  <JudgeTableRow
                    key={index}
                    index={index}
                    fname={entry.fname}
                    lname={entry.lname}
                    phone={entry.phone}
                    email={entry.email}
                    admin={entry.isadmin}
                    ballots={entry.count}
                    onEdit={() => {}}//handleEdit(entry)} // Open modal with entry details on Edit
                  />
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center py-4">No matching entries found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
      <ResultModal isOpen={isModalOpen} onClose={handleCloseModal} entry={selectedEntry} />
      <JudgeForm isOpen={isRegJudgeOpen} onClose={onJClose} />
    </div>
  );
}

export default ViewJudges;
